module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.715d593.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/fontawesome-6.6.0/webfonts/fa-brands-400.woff2
// module id = BpKE
// module chunks = 2